import { GlForm, GlFormInput, GlButton } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
export default {
    name: 'BoardNewItem',
    i18n: {
        cancel: __('Cancel')
    },
    components: {
        GlForm,
        GlFormInput,
        GlButton
    },
    props: {
        list: {
            type: Object,
            required: true
        },
        disableSubmit: {
            type: Boolean,
            required: false,
            default: false
        },
        submitButtonTitle: {
            type: String,
            required: false,
            default: __('Create issue')
        }
    },
    emits: [
        'form-cancel',
        'form-submit'
    ],
    data () {
        return {
            title: ''
        };
    },
    computed: {
        inputFieldId () {
            // eslint-disable-next-line @gitlab/require-i18n-strings
            return `${this.list.id}-title`;
        },
        isIssueTitleEmpty () {
            return this.title.trim() === '';
        },
        isCreatingIssueDisabled () {
            return this.isIssueTitleEmpty || this.disableSubmit;
        }
    },
    methods: {
        handleFormCancel () {
            this.title = '';
            this.$emit('form-cancel');
        },
        handleFormSubmit () {
            const { title, list } = this;
            this.$emit('form-submit', {
                title: title.trim(),
                list
            });
        }
    }
};
